/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Sources_TitleInputs */

const es_home_sources_title = /** @type {(inputs: Home_Sources_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuentes de datos conectables`)
};

const en_home_sources_title = /** @type {(inputs: Home_Sources_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectable data sources`)
};

/**
* | output |
* | --- |
* | "Connectable data sources" |
*
* @param {Home_Sources_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_sources_title = /** @type {((inputs?: Home_Sources_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Sources_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_sources_title(inputs)
	return en_home_sources_title(inputs)
});
export { home_sources_title as "home.sources.title" }